import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

const Wrapper = styled.div`
  margin: 57px 0 0 60px;
  display: flex;
  justify-content: center;
  background-color: #e4e5e7;
  padding: 10px 0;
  display: flex;
  flex-direction: column;

  ${mediaMaxWidth.tablet} {
    margin: 57px 0 0 0;
    padding: 0;
  }
`;

export { Wrapper as default };
